import { useState } from "react";
import { DEFAULT_TASK_FIELD_COLOR } from "../../../../../custom-fields/consts";
import { DropdownValueListItem } from "./types";

const NEW_VALUE_INITIAL_STATE: DropdownValueListItem = {
  id: "new",
  text: "",
  color: DEFAULT_TASK_FIELD_COLOR,
};

export const useDropdownValueList = () => {
  const [newItem, setNewItem] = useState<DropdownValueListItem | null>(null);

  const [editingItemId, setEditingItemId] = useState<
    DropdownValueListItem["id"] | null
  >(null);

  const handleChangeEditingState = (
    id: DropdownValueListItem["id"],
    isEditing: boolean
  ) => setEditingItemId(isEditing ? id : null);

  const handleDismissNewItem = () => {
    setNewItem(null);
    setEditingItemId(null);
  };

  const handleAddValueClick = () => {
    setNewItem(NEW_VALUE_INITIAL_STATE);
    setEditingItemId(NEW_VALUE_INITIAL_STATE.id);
  };

  return {
    newItem,
    editingItemId,
    handleChangeEditingState,
    handleDismissNewItem,
    handleAddValueClick,
    setEditingItemId,
    setNewItem,
  };
};
